import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Core } from "@faire/design-tokens";
import { Column } from "@faire/web--source/slate/Layout";
import Radio from "@faire/web--source/slate/Radio";
import { getSpacing } from "@faire/web--source/slate/spacing";
import { Typography } from "@faire/web--source/slate/Typography";
import React from "react";
import styled from "styled-components";
export var RadioMFAOption = function(param) {
    var onClick = param.onClick, title = param.title, value = param.value, label = param.label, active = param.active, ariaLabel = param.ariaLabel;
    return /*#__PURE__*/ _jsx(StyledRadio, {
        label: label !== null && label !== void 0 ? label : title,
        align: "flex-start",
        "aria-label": ariaLabel !== null && ariaLabel !== void 0 ? ariaLabel : title,
        onClick: onClick,
        active: active,
        children: /*#__PURE__*/ _jsxs(RadioLabelColumn, {
            children: [
                /*#__PURE__*/ _jsx(Typography, {
                    children: title
                }),
                /*#__PURE__*/ _jsx(RadioValueTypography, {
                    color: Core.text.subdued,
                    children: value
                })
            ]
        })
    });
};
var RadioValueTypography = styled(Typography).withConfig({
    componentId: "sc-a1708530-0"
})([
    "white-space:nowrap;overflow:hidden;text-overflow:ellipsis;"
]);
var RadioLabelColumn = styled(Column).withConfig({
    componentId: "sc-a1708530-1"
})([
    "padding:",
    ";width:calc(100% - 10px);"
], getSpacing(0, "1x"));
var StyledRadio = styled(Radio).withConfig({
    componentId: "sc-a1708530-2"
})([
    "width:100%;label{width:100%;}"
]);
